import {isNullOrEmpty} from './HelperUtils';

export const generateIdentifier = (prefix = 'id', delimeter = '_', isUUID = false): string => {
    if (isUUID) {
        return generateUUID();
    }

    if (isNullOrEmpty(prefix)) {
        prefix = 'id';
    }

    if (!((/[._-]/).test(delimeter))) {
        delimeter = '_';
    }

    let time = new Date().getTime().toString();
    let random = Math.random().toString().substring(2, 15);

    return encodeURI(prefix) + delimeter + time + delimeter + random;
};

export const generateUUID = () => {
    let time = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = (time + Math.random() * 16) % 16 | 0;
        time = Math.floor(time / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });

    return uuid;
};
